import { createSlice } from "@reduxjs/toolkit";

import { fetchMappings } from "./mappingSlice";

const initialState = {
  countries: [
    "Denmark",
    "Norway",
    "Switzerland",
    "Finland",
    "Australia",
    "UK",
    // "Sweden",
  ],
  selectedCountry: "Denmark",
  searchInput: "",
  radioFilter: "search by company",
};

export const searchWindowSlice = createSlice({
  name: "searchWindow",
  initialState,
  reducers: {
    onSelectedCountry(state, { payload }) {
      state.selectedCountry = payload;
      if (payload === "Sweden" || payload === "Finland") {
        if (state.radioFilter !== "search by vat") {
          state.radioFilter = "search by vat";
        }
      } else {
        state.radioFilter = "search by company";
      }
      state.searchInput = "";
    },
    storeSearchWindowInput(state, { payload }) {
      state.searchInput = payload;
    },
    onChangeRadioFilter(state, { payload }) {
      state.radioFilter = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMappings.fulfilled, (state, action) => {
      const { preference } = action.payload;
      state.selectedCountry = preference.country
        ? preference.country
        : "Denmark";
      preference.country === "Finland"
        ? (state.radioFilter = "search by vat")
        : (state.radioFilter = "search by company");
    });
  },
});

export const {
  onSelectedCountry,
  storeSearchWindowInput,
  onChangeRadioFilter,
} = searchWindowSlice.actions;

export default searchWindowSlice.reducer;
